import React from 'react';
import { Phone, Mail, Facebook, Instagram } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4">
              SIA <span className="text-gray-400">Grúas</span>
            </h3>
            <p className="text-gray-400 mb-4 leading-relaxed">
              Servicio profesional de traslado de vehículos y maquinaria en Mendoza.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('inicio')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('servicios')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Servicios
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('nosotros')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Sobre Nosotros
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contacto')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-gray-400 flex-shrink-0 mt-0.5" />
                <div>
                  <a href="tel:2612073173" className="text-gray-400 hover:text-white transition-colors block">
                    261-2073173
                  </a>
                  <a href="tel:2613840960" className="text-gray-400 hover:text-white transition-colors block">
                    261-3840960
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-gray-400 flex-shrink-0 mt-0.5" />
                <a 
                  href="mailto:siagruascarrasco@gmail.com"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  siagruascarrasco@gmail.com
                </a>
              </li>
            </ul>
          </div>

          {/* Business Hours */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Horarios</h4>
            <div className="space-y-2">
              <p className="text-gray-400">
                <span className="font-medium text-white">Lunes a Domingo</span>
              </p>
              <p className="text-gray-400">06:00 AM - 00:30 AM</p>
              <p className="text-sm text-gray-500 mt-4">
                Zona de cobertura: Mendoza - Zona este
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {new Date().getFullYear()} SIA Grúas. Todos los derechos reservados.
            </p>
            <p className="text-gray-500 text-sm">
              Mendoza, Argentina
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
